var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83293 0.1878C4.95808 0.0676084 5.11473 0 5.29522 0H15.6521C16.8773 0 17.875 0.978217 17.875 2.17925V17.8199C17.875 19.021 16.8738 19.9992 15.6521 19.9992L3.09786 20C1.87615 20 0.875 19.0184 0.875 17.8207V4.33349L0.978016 3.98793L4.83293 0.1878ZM5.4791 8.95182H13.2708C14.1315 8.95182 14.1315 7.66978 13.2708 7.66978H5.4791C4.61838 7.66978 4.61838 8.95182 5.4791 8.95182ZM7.20397 16.2118H11.5459C12.4067 16.2118 12.4067 14.9298 11.5459 14.9298H7.20397C6.34325 14.9298 6.34325 16.2118 7.20397 16.2118ZM5.4791 12.5819H13.2708C14.1315 12.5819 14.1315 11.2999 13.2708 11.2999H5.4791C4.61838 11.2999 4.61838 12.5819 5.4791 12.5819ZM2.18263 4.97472V17.821C2.18263 18.3176 2.59128 18.7182 3.09784 18.7182H15.6521C16.1612 18.7182 16.5673 18.3117 16.5673 17.821V2.17945C16.5673 1.68616 16.1553 1.28219 15.6521 1.28219H5.94904V4.33366C5.94904 4.68754 5.65616 4.97468 5.2952 4.97468L2.18263 4.97472ZM4.64131 3.69268V2.18861L3.10714 3.69268H4.64131Z",
    fill: "#3751FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIncomplete);
export default __webpack_public_path__ + "static/media/review_incomplete.3a8f859d9d2f63be8b2f0d1dbce89af4.svg";
export { ForwardRef as ReactComponent };